// state definition
export interface ICSIDUserStatusState {
    isLoading: boolean;
    csidUserStatus: ICSIDUserStatus;
    isSSNPinning: boolean;
    refreshingCSIDUserStatus: boolean;
    globalQuestionTryCount: number;
    globalTUOTPTryCount: number;
    globalTUOTPRequestedCount: number;
}

// action(s)
export const CSID_REQUEST_USER_STATUS = "CSID/REQUEST_USER_STATUS";
export const CSID_RESPONSE_USER_STATUS = "CSID/RESPONSE_USER_STATUS";
export const CSID_SSN_PINNING_STATUS = "CSID/CSID_SSN_PINNING_STATUS";
export const CSID_REFRESHING_USER_STATUS = "CSID/REFRESHING_USER_STATUS";
export const SET_GLOBAL_QUESTION_TRY_COUNT = "SET_GLOBAL_QUESTION_TRY_COUNT";
export const SET_GLOBAL_TU_OTP_TRY_COUNT = "SET_GLOBAL_TU_OTP_TRY_COUNT";
export const SET_GLOBAL_TU_OTP_REQUESTED_COUNT = "SET_GLOBAL_TU_OTP_REQUESTED_COUNT";

export interface IRequestCSIDUserStatusAction {
    type: typeof CSID_REQUEST_USER_STATUS;
    isLoading: boolean;
}

export interface IResponseCSIDUserStatusAction {
    type: typeof CSID_RESPONSE_USER_STATUS;
    csidUserStatus: ICSIDUserStatus;
}

export interface ISSNPinningStatusAction {
    type: typeof CSID_SSN_PINNING_STATUS;
    isSSNPinning: boolean;
}

export interface ISetGlobalQuestionTryCountAction {
    type: typeof SET_GLOBAL_QUESTION_TRY_COUNT;
    globalQuestionTryCount: number;
}

export interface ISetGlobalTUOTPTryCountAction {
    type: typeof SET_GLOBAL_TU_OTP_TRY_COUNT;
    globalTUOTPTryCount: number;
}

export interface ISetGlobalTUOTPRequestedCountAction {
    type: typeof SET_GLOBAL_TU_OTP_REQUESTED_COUNT;
    globalTUOTPRequestedCount: number;
}

export interface IrefreshingCSIDUserStatusAction {
    type: typeof CSID_REFRESHING_USER_STATUS;
    refreshingCSIDUserStatus: boolean;
}

export type CSIDUserStatusActions =
    | IRequestCSIDUserStatusAction
    | IResponseCSIDUserStatusAction
    | ISSNPinningStatusAction
    | IrefreshingCSIDUserStatusAction
    | ISetGlobalQuestionTryCountAction
    | ISetGlobalTUOTPTryCountAction
    | ISetGlobalTUOTPRequestedCountAction;

// Ajax response definition
export interface ICSIDUserStatus {
    "status-code": number;
    message: string;
    data: any;
    "auth-status": string;
    "ssn-status": string;
    "dob-status": string;
    "address-status": string;
    isIDFUser: boolean;
    isTUUser: boolean;
    productAuthenticationType: string;
    csidActivationStatus: string;
    l3AuthProvider: L3AuthProvider;
}

export interface L3AuthProvider {
    isTU: boolean;
    isIDF: boolean;
    isExperian: boolean;
}

export interface IAddress {
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
}
